export default "__VITE_ASSET__d89426d4__"